import React, { useEffect, useRef } from "react";

const isTouchDevice = () =>
  "ontouchstart" in window || navigator.maxTouchPoints > 0;

export default function LuxuryCursor() {
  const dot = useRef(null);

  useEffect(() => {
    if (isTouchDevice()) return;
    const update = (e) => {
      const d = dot.current;
      d.style.left = `${e.clientX}px`;
      d.style.top = `${e.clientY}px`;
    };
    document.addEventListener("mousemove", update);
    document.body.style.cursor = "none";
    return () => {
      document.removeEventListener("mousemove", update);
      document.body.style.cursor = "";
    };
  }, []);

  if (isTouchDevice()) return null;

  return (
    <div
      ref={dot}
      className="
        fixed pointer-events-none z-[10000]
        w-6 h-6
        rounded-full
        bg-gold/80
        shadow-[0_0_85px_38px_rgba(226,193,109,0.22)]
        ring-4 ring-gold ring-opacity-20
        -translate-x-1/2 -translate-y-1/2
        blur-[6px]
        transition-transform
        duration-75
      "
      style={{
        left: 0,
        top: 0,
        transition: "left 45ms, top 45ms",
        mixBlendMode: "lighten",
        opacity: 0.93
      }}
      aria-hidden
    />
  );
}
